var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuscripciones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8836 7.79451C24.0973 9.62899 24.7466 11.779 24.7511 13.9786C24.7556 16.1783 24.1153 18.331 22.9092 20.1704C21.7031 22.0099 19.9842 23.4555 17.9652 24.3283C15.9461 25.2011 13.7155 25.4629 11.5492 25.0813M4.11635 20.2055C2.90269 18.3705 2.25369 16.22 2.24965 14.02C2.24562 11.82 2.88672 9.66705 4.09364 7.82765C5.30056 5.98824 7.02031 4.54307 9.04009 3.67098C11.0599 2.79888 13.291 2.53814 15.4575 2.92101M16.875 14C16.875 15.864 15.3639 17.375 13.5 17.375C11.636 17.375 10.125 15.864 10.125 14C10.125 12.136 11.636 10.625 13.5 10.625C15.3639 10.625 16.875 12.136 16.875 14ZM23.625 6.12501C23.625 7.36765 22.6176 8.37501 21.375 8.37501C20.1323 8.37501 19.125 7.36765 19.125 6.12501C19.125 4.88237 20.1323 3.87501 21.375 3.87501C22.6176 3.87501 23.625 4.88237 23.625 6.12501ZM7.87498 21.875C7.87498 23.1176 6.86762 24.125 5.62498 24.125C4.38234 24.125 3.37498 23.1176 3.37498 21.875C3.37498 20.6324 4.38234 19.625 5.62498 19.625C6.86762 19.625 7.87498 20.6324 7.87498 21.875Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuscripciones);
export default __webpack_public_path__ + "static/media/suscripciones.0b1d42d5996d012f5f6c7fcd5cecb9c1.svg";
export { ForwardRef as ReactComponent };